import { defineMessages } from 'react-intl';

export const paymentMethodsMessages = defineMessages({
    paymentMethods: {
        id: 'payment-methods',
        defaultMessage: 'Payment methods',
    },
    methods: {
        id: 'methods',
        defaultMessage: 'Methods',
    },
    method: {
        id: 'method',
        defaultMessage: 'Method',
    },
    customer: {
        id: 'customer',
        defaultMessage: 'Customer',
    },
    type: {
        id: 'type',
        defaultMessage: 'Type',
    },
    isPrimary: {
        id: 'is-primary',
        defaultMessage: 'Is primary',
    },
    deleteCustomerPaymentMethod: {
        id: 'delete-customer-payment-method',
        defaultMessage: 'Delete customer payment method',
    },
    deleteCustomerPaymentMethodSuccess: {
        id: 'delete-customer-payment-method-success',
        defaultMessage: 'Payment method deleted',
    },
    deleteCustomerPaymentMethodSuccessDescription: {
        id: 'delete-customer-payment-method-success-description',
        defaultMessage: 'The payment method has been successfully deleted.',
    },
    confirmDeleteCustomerPaymentMethod: {
        id: 'confirm-delete-customer-payment-method',
        defaultMessage: 'Are you sure you want to delete this customer payment method? This action cannot be undone.',
    },
    deleteCustomerPaymentMethodSubtitle: {
        id: 'delete-customer-payment-method-subtitle',
        defaultMessage: 'Permanently delete customer payment method',
    },
    token: {
        id: 'token',
        defaultMessage: 'Token',
    },
    details: {
        id: 'details',
        defaultMessage: 'Details',
    },
    createCustomerPaymentMethodSuccess: {
        id: 'create-customer-payment-method-success',
        defaultMessage: 'Payment method created',
    },
    createCustomerPaymentMethodSuccessDescription: {
        id: 'create-customer-payment-method-success-description',
        defaultMessage: 'Payment method {entry} has been successfully created.',
    },
    addCustomerPaymentMethodSubtitle: {
        id: 'add-customer-payment-method-subtitle',
        defaultMessage: 'Create a new payment method',
    },
    editPaymentMethodSubtitle: {
        id: 'edit-payment-method-subtitle',
        defaultMessage: 'Edit payment method {entity}',
    },
    updatePaymentMethodSuccess: {
        id: 'update-payment-method-success',
        defaultMessage: 'Payment method updated',
    },
    updatePaymentMethodSuccessDescription: {
        id: 'update-payment-method-success-description',
        defaultMessage: 'Payment method {entity} has been successfully updated.',
    },
});
